import { z } from 'zod';
/**
 * T-AI-RAG-001 — schemas for the sales-engineer assistant's retrieval endpoint.
 * Source of truth for both the backend route (OpenAPI) and frontend client.
 *
 * Scope here is RETRIEVE-ONLY (static-knowledge RAG). Chat/generation +
 * tool-calling over CRM data land in T-AI-RAG-002/003 and add their own schemas.
 */
export const AssistantRetrieveRequestSchema = z.object({
    query: z.string().min(1).max(2000),
    k: z.number().int().min(1).max(50).optional(),
});
export const RetrievedChunkSchema = z.object({
    id: z.string(),
    source: z.string(),
    sourceRef: z.string(),
    chunkIndex: z.number().int().nonnegative(),
    content: z.string(),
    /** Cosine similarity in [0,1]. */
    score: z.number(),
});
export const AssistantRetrieveResponseSchema = z.object({
    query: z.string(),
    chunks: z.array(RetrievedChunkSchema),
});
// ─── T-AI-RAG-002: chat (tool-calling) ──────────────────────────────────────
export const AssistantChatTurnSchema = z.object({
    role: z.enum(['user', 'assistant']),
    content: z.string(),
});
export const AssistantChatRequestSchema = z.object({
    message: z.string().min(1).max(4000),
    /** Prior turns (user/assistant) for multi-turn context. */
    history: z.array(AssistantChatTurnSchema).max(20).optional(),
});
export const AssistantCitationSchema = z.object({
    sourceRef: z.string(),
    score: z.number(),
});
export const AssistantToolTraceEntrySchema = z.object({
    name: z.string(),
    arguments: z.string(),
});
export const AssistantChatResponseSchema = z.object({
    answer: z.string(),
    citations: z.array(AssistantCitationSchema),
    toolTrace: z.array(AssistantToolTraceEntrySchema),
});
// ─── RIG-364: per-user chat history ─────────────────────────────────────────
/** One persisted turn of a rep's Ask-Howie history. */
export const AssistantHistoryMessageSchema = z.object({
    id: z.string(),
    role: z.enum(['user', 'assistant']),
    content: z.string(),
    /** Citations for assistant turns; empty for user turns. */
    citations: z.array(AssistantCitationSchema),
    createdAt: z.string(),
});
/** GET /api/v1/assistant/history — the caller's saved conversation, oldest-first. */
export const AssistantHistoryResponseSchema = z.object({
    messages: z.array(AssistantHistoryMessageSchema),
});
//# sourceMappingURL=assistant.js.map